import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

function Navbar() {
  const [active, setActive] = useState('home');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname !== '/') {
      setActive('projects');
      return;
    }
    const hash = location.hash.replace('#', '');
    setActive(hash || 'home');
  }, [location.pathname, location.hash]);

  useEffect(() => {
    if (location.pathname !== '/') return undefined;

    const sectionIds = ['home', 'projects'];
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

        if (visible.length > 0) {
          const topId = visible[0].target.id;
          setActive((prev) => (prev === topId ? prev : topId));
        }
      },
      { threshold: [0.4], rootMargin: '-30% 0px -30% 0px' }
    );

    const targets = sectionIds
      .map((id) => document.getElementById(id))
      .filter(Boolean);
    targets.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [location.pathname]);

  const makeClass = (key) =>
    `nav-link${active === key ? ' nav-link--active' : ''}`;

  const handleNav = (id) => (e) => {
    e.preventDefault();
    setActive(id);
    if (location.pathname !== '/') {
      navigate(`/#${id}`);
      return;
    }
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    window.history.replaceState(null, '', `#${id}`);
  };

  return (
    <nav className="navbar">
      <div className="navbar__brand">Saman Bandara</div>
      <div className="navbar__actions">
        <Link
          className={makeClass('home')}
          to={{ pathname: '/', hash: '#home' }}
          onClick={handleNav('home')}
        >
          home
        </Link>
        <Link
          className={makeClass('projects')}
          to={{ pathname: '/', hash: '#projects' }}
          onClick={handleNav('projects')}
          aria-current={active === 'projects' ? 'page' : undefined}
        >
          projects
        </Link>
      </div>
    </nav>
  );
}

export default Navbar;
